
import config from '../config';
import Url from 'c-url';
import env from 'c-nenv';
import fb from './fb';
import twitter from './twitter';
import lang from '../lang/index';

const sns = {

    /**
     * 前往sns平台进行授权获取code(统一接口提供给外部调用)
     */
    jumpToSNS : function (platfrom, scope) {
        this[platfrom + 'JumpForCode'](scope);
    },
    

    /**
     * 前往微信授权中心
     */
    wechatJumpForCode : function (scope) {
        let self = this;
        let urlForCode = 'https://open.weixin.qq.com/connect/oauth2/authorize?';
        let wechat = config.upInfoInPlatform.wechat;
        let appid;

        if (Url.query('env') == 'stage') {
            appid = wechat['appid_stage'];
        } else {
            appid = wechat.appid;
        }

        var result = {
            appid : appid,
            redirect_uri : self.getRedirectUri(),
            response_type : 'code',
            scope : 'snsapi_base',
            state : '1'
        };

        if (scope == 'snsapi_userinfo') {
            $.extend(result , {
                scope : scope,
                state : '2'
            });
        }
        
        self.jump(urlForCode + $.param(result) + '#wechat_redirect');
        
    },
    
    
    qqJumpForCode : function () {

        var urlForCode = 'https://graph.qq.com/oauth2.0/authorize?display=mobile&response_type=code&scope=get_user_info';
        if (Url.query('display') == 'pcweb') {
            urlForCode = 'https://graph.qq.com/oauth2.0/authorize?response_type=code&scope=get_user_info';
        }
        var result = {
            client_id : '101402313',
            state : Url.query('stage'),
            redirect_uri : this.getRedirectUri()
        };

        this.jump(urlForCode + '&' + $.param(result));
    },

    twitterJumpForCode: function(requestToken) {
        let urlForCode = 'https://api.twitter.com/oauth/authenticate?oauth_token=' + requestToken;
        this.jump(urlForCode);
    },

    
    weiboJumpForCode : function () {
        var urlForCode = 'https://api.weibo.com/oauth2/authorize';
        var result = {
            client_id : config.upInfoInPlatform.weibo.appid,
            response_type : 'code',
            redirect_uri : this.getRedirectUri()
        };
        
        this.jump(urlForCode + '?' + $.param(result));
    },

    /**
     * 获得重定向URL
     */
    getRedirectUri : function () {
        var uri = 'http://' + location.hostname + location.pathname;
        var target_uri = Url.query('target_uri') || '';

        var result = {
            target_uri : target_uri.indexOf('//') >= 0 ? encodeURIComponent(target_uri) : target_uri,
        };
        
        if (config.env()){
            result.env = config.env();
        }
        
        Object.assign(result, {
            oauthtype: Url.query('oauthtype'),
            lang: lang.type,
            channel: Url.query('channel'),
            ignoreCountryCode: Url.query('ignoreCountryCode'),
            multiLoginChannel: Url.query('multiLoginChannel'),
        });
        
        return uri + '?' + $.param(result);
    },

    /**
     * 链接跳转
     */
    jump : function (url) {
        location.replace(url);
    }

};

export default sns;
export {
    fb,
    twitter
};




// WEBPACK FOOTER //
// ./js/sns/index.js